import { useEffect, useState } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import MenuConfig from '../../../../constants/MenuConfig';
import Module from '../../../../constants/Module';
import { hasMenuAccess } from '../../../../utils/ModuleAccessUtils';
import { ProductStockStatus, fetchProductStock } from '../../../../utils/ProductStockUtils';

const OrderStockNotice = ({ product, branch }) => {
    const { t } = useTranslation();
    const [result, setResult] = useState(null);
    const [revision, setRevision] = useState(0);
    const productId = product?.value;
    const branchId = branch?.value;
    const selectionKey = `${productId}:${branchId}`;

    useEffect(() => {
        let active = true;
        setResult(null);
        if (!productId) return;

        const checkStock = async () => {
            const { status } = await fetchProductStock(productId, branchId);
            if (!active) return;
            setResult({ selectionKey, status });
        };

        checkStock();
        // Reconsulta ao voltar da reposição; respostas antigas não podem mudar o aviso
        // depois que o operador troca o produto ou a filial.
        const refresh = () => setRevision(value => value + 1);
        window.addEventListener('focus', refresh);
        return () => {
            active = false;
            window.removeEventListener('focus', refresh);
        };
    }, [productId, branchId, selectionKey, revision]);

    if (!result || result.selectionKey !== selectionKey
        || result.status === ProductStockStatus.AVAILABLE
        || result.status === ProductStockStatus.UNTRACKED) return null;

    if (result.status === ProductStockStatus.BRANCH) {
        return <Alert variant="info">{t('order_stock_choose_branch')}</Alert>;
    }

    if (result.status === ProductStockStatus.UNAVAILABLE) {
        return (
            <Alert variant="warning">
                <p className="mb-2">{t('order_stock_unavailable')}</p>
                <Button variant="outline-secondary" size="sm" onClick={() => setRevision(value => value + 1)}>
                    {t('order_stock_retry')}
                </Button>
            </Alert>
        );
    }

    return (
        <Alert variant="danger">
            <strong>{t('order_stock_empty_title', { product: product.label })}</strong>
            <p className="mt-2 mb-2">{t('order_stock_empty_description', { branch: branch.label })}</p>
            {hasMenuAccess(Module.STOCK_CONTROL, 'restock') ? (
                <>
                    <p className="mb-2">{t('order_stock_restock_hint')}</p>
                    <a href={`${MenuConfig.stock_control.restock.route}/new`} target="_blank" rel="noopener noreferrer" className="alert-link order-stock-notice__restock-link">
                        {t('order_stock_restock_link')}
                    </a>
                </>
            ) : <p className="mb-0">{t('order_stock_contact_manager')}</p>}
        </Alert>
    );
};

export default OrderStockNotice;
